import { gql } from '@apollo/client'

export const GRANT_RESOURCE_ACCESS = gql`
  mutation GrantResourceAccess($input: GrantResourceAccessInput!) {
    grantResourceAccess(input: $input) {
      success
      message
    }
  }
`
export const REVOKE_RESOURCE_ACCESS = gql`
  mutation RevokeResourceAccess($input: RevokeResourceAccessInput!) {
    revokeResourceAccess(input: $input) {
      success
      message
    }
  }
`

export const WEBCAL_QUERY = gql`
  query WebcalQuery {
    currentUser {
      externalId
    }
  }
`
